import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import useUiuxStore from "src/store/useUiuxStore";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";

import { defaultMST1010_R01Filter, useMST1010_R01Store } from "./Store_MST1010_R01";



export const SearchSection_MST1010_R01 = () => {

  const { brandCdList, itemGroupList, itemAccountList } = useCommonCodeStore();
  const { MST1010_R01Filter, setMST1010_R01Filter } = useMST1010_R01Store();
  const { setCodeSearchModalProps } = useUiuxStore();
  const searchItemCdFocusId = "searchItemCd_MST1010_R01";

  const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
    {
      fieldName: "itemCd",
      category: "품목코드",
      focusId: searchItemCdFocusId,
      responseMapping: {
        itemCd: "itemCd",
        itemNm: "itemNm",
      },
      extraFilter: () => ({
        itemCd: MST1010_R01Filter.itemCd || "",
        itemNm: MST1010_R01Filter.itemNm || "",
      }),
    },
  ];

  const { getFieldHandlers } = useInfoFormEvents({
    editData: MST1010_R01Filter,
    setEditData: setMST1010_R01Filter,
    defaultData: defaultMST1010_R01Filter,
    infoFieldConfigs,
    setCodeSearchModalProps,
    formName: "MST1010_R01_search",
  });

  return (
	<SearchSectionForm>
		<SearchDropDownForm
			label="브랜드"
			value={MST1010_R01Filter.brandCd}
			optionList={brandCdList}
			// onChangeItem prop 사용, setBrandCd는 SysCodeDto를 받음
			onChangeItem={(selectedItem) => setMST1010_R01Filter({ brandCd: selectedItem?.minorCd || ''})}	
		/>
		<SearchDropDownForm
			label="품목그룹"
			value={MST1010_R01Filter.itemGroup}
			optionList={itemGroupList}
			onChangeItem={(selectedItem) => setMST1010_R01Filter({ itemGroup: selectedItem?.minorCd || ''})}
		/>
		<SearchDropDownForm
			label="품목계정"
			value={MST1010_R01Filter.itemAccount}
			optionList={itemAccountList}
			onChangeItem={(selectedItem) => setMST1010_R01Filter({ itemAccount: selectedItem?.minorCd || ''})}
		/>
		<SearchCodeModalForm
			label="품목코드"
			value={MST1010_R01Filter.itemCd}
			valueLabel={MST1010_R01Filter.itemNm}
			handleFoucsId={searchItemCdFocusId}
			onChange={getFieldHandlers("itemCd").onChange}
			onDoubleClick={getFieldHandlers("itemCd").onDoubleClick}
			onKeyDown={getFieldHandlers("itemCd").onEnterKeyDown}
		/>
	</SearchSectionForm>
  )
}